// Port of api/fuel/app/classes/insights/game/timeline.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

function ordinal(n) {
	var s = ['th', 'st', 'nd', 'rd']
	var v = n % 100
	return n + (s[(v - 20) % 10] || s[v] || s[0])
}

export default Segment.extend({
	name: 'timeline',
	priority: 6,
	requires: ['init'],
	detail: false,
	types: [Constants.TYPE_USER],
	methods: {
		ordinal: ordinal
	},
	run: function(type, owner, userIndex, detail, filter, vars) {

		var userId = owner.get_id()
		var gameId = parseInt(vars.id, 10)
		var username = owner.get_name().toLowerCase()
		var playsRaw = this._data.plays_raw || []
		var playersRaw = this._data.players_raw || []
		var comment = this._data.comment
		var events = []

		var milestones = [1, 2, 3, 5, 10, 25, 50, 100, 200, 500, 1000]
		var runningTotal = 0
		var milestoneIndex = 0
		var winMilestones = [1, 5, 10, 25, 50, 100]
		var winCount = 0
		var winMilestoneIndex = 0
		var playersByPlay = {}
		var opponentCounts = {}
		var opponentMilestones = [1, 5, 10, 25, 50, 100]
		var locationsSeen = {}
		var yearsSeen = {}
		var bestScore = null
		var bestScoreDate = null
		var byYear = {}

		for (var pr = 0; pr < playersRaw.length; pr++) {
			var playId = playersRaw[pr].play_id
			if (!playersByPlay[playId]) playersByPlay[playId] = []
			playersByPlay[playId].push(playersRaw[pr])
		}

		for (var i = 0; i < playsRaw.length; i++) {
			var play = playsRaw[i]
			var date = parseInt(play.play_date, 10)
			var count = parseInt(play.play_count, 10)
			var playIdValue = parseInt(play.play_id, 10)

			if (date <= 0) continue

			runningTotal += count

			var playYear = Util.date('Y', date)
			if (!byYear[playYear]) byYear[playYear] = 0
			byYear[playYear] += count

			while (milestoneIndex < milestones.length && runningTotal >= milestones[milestoneIndex]) {
				var milestone = milestones[milestoneIndex]
				events.push({
					date: date,
					type: 'play',
					label: ordinal(milestone) + ' play',
					detail: null,
					icon: 'dice',
					playId: playIdValue
				})
				milestoneIndex++
			}

			var year = Util.date('Y', date)
			if (!yearsSeen[year]) {
				yearsSeen[year] = true
				if (Object.keys(yearsSeen).length > 1) {
					events.push({
						date: date,
						type: 'play',
						label: 'First play of ' + year,
						detail: ordinal(runningTotal) + ' play',
						icon: 'calendar',
						playId: playIdValue
					})
				}
			}

			var location = (play.play_location || '').trim()
			if (location !== '' && !locationsSeen[location.toLowerCase()]) {
				locationsSeen[location.toLowerCase()] = true
				if (Object.keys(locationsSeen).length > 1) {
					events.push({
						date: date,
						type: 'location',
						label: 'New location',
						detail: location + ' · ' + ordinal(runningTotal) + ' play',
						icon: 'location',
						playId: playIdValue
					})
				}
			}

			if (playersByPlay[playIdValue]) {
				for (var pj = 0; pj < playersByPlay[playIdValue].length; pj++) {
					var player = playersByPlay[playIdValue][pj]
					var isSelf = this.isSelf(player, userId, username)
					var score = player.player_score

					if (isSelf) {
						if (parseInt(player.player_win, 10)) {
							winCount++
							while (winMilestoneIndex < winMilestones.length && winCount >= winMilestones[winMilestoneIndex]) {
								var winMilestone = winMilestones[winMilestoneIndex]
								events.push({
									date: date,
									type: 'win',
									label: ordinal(winMilestone) + ' win',
									detail: null,
									icon: 'trophy',
									playId: playIdValue
								})
								winMilestoneIndex++
							}
						}

						if (score !== '' && score !== null) {
							var scoreValue = parseFloat(score)
							if (bestScore === null || scoreValue > bestScore) {
								bestScore = scoreValue
								bestScoreDate = date
							}
						}
					} else {
						var playerUserId = parseInt(player.user_id, 10)
						var playerName = player.player_name
						var opponentKey = playerUserId ? ('u' + playerUserId) : ('n' + (playerName || 'unknown').toLowerCase())
						var opponentName = playerName || 'Unknown'

						if (!opponentCounts[opponentKey]) {
							opponentCounts[opponentKey] = {
								count: 0,
								name: opponentName,
								milestoneIndex: 0
							}
						}

						opponentCounts[opponentKey].count++

						while (
							opponentCounts[opponentKey].milestoneIndex < opponentMilestones.length &&
							opponentCounts[opponentKey].count >= opponentMilestones[opponentCounts[opponentKey].milestoneIndex]
						) {
							var opponentMilestone = opponentMilestones[opponentCounts[opponentKey].milestoneIndex]
							events.push({
								date: date,
								type: 'opponent',
								label: ordinal(opponentMilestone) + ' play with ' + opponentCounts[opponentKey].name,
								detail: ordinal(runningTotal) + ' play',
								icon: 'users',
								opponentSlug: Util.slug(Util.englishify(opponentName))
							})
							opponentCounts[opponentKey].milestoneIndex++
						}
					}
				}
			}
		}

		var resultStreak = 0
		var resultStreakType = null

		for (var rs = 0; rs < playsRaw.length; rs++) {
			var streakPlay = playsRaw[rs]
			var streakDate = parseInt(streakPlay.play_date, 10)
			var streakPlayId = parseInt(streakPlay.play_id, 10)

			if (streakDate <= 0 || !playersByPlay[streakPlayId]) continue

			var selfWin = null

			for (var sp = 0; sp < playersByPlay[streakPlayId].length; sp++) {
				if (this.isSelf(playersByPlay[streakPlayId][sp], userId, username)) {
					selfWin = parseInt(playersByPlay[streakPlayId][sp].player_win, 10)
					break
				}
			}

			if (selfWin === null) continue

			var currentType = selfWin ? 'win' : 'loss'
			if (currentType === resultStreakType) {
				resultStreak++
			} else {
				if (resultStreak >= 3 && resultStreakType !== null) {
					events.push({
						date: streakDate,
						type: resultStreakType === 'win' ? 'win' : 'streak',
						label: resultStreakType === 'win' ? 'Winning streak ended' : 'Losing streak broken',
						detail: (resultStreakType === 'win' ? 'Won ' : 'Lost ') + resultStreak + ' in a row',
						icon: resultStreakType === 'win' ? 'fire' : 'heart-broken'
					})
				}

				resultStreakType = currentType
				resultStreak = 1
			}
		}

		if (resultStreak >= 3 && resultStreakType !== null) {
			events.push({
				date: Util.time(),
				type: resultStreakType === 'win' ? 'win' : 'streak',
				label: resultStreakType === 'win' ? 'Winning streak active' : 'Losing streak active',
				detail: (resultStreakType === 'win' ? 'Won ' : 'Lost ') + resultStreak + ' in a row',
				icon: resultStreakType === 'win' ? 'fire' : 'heart-broken'
			})
		}

		var playsByDate = {}
		for (var pd = 0; pd < playsRaw.length; pd++) {
			var dayDate = parseInt(playsRaw[pd].play_date, 10)
			if (dayDate <= 0) continue
			var dayKey = Util.date('Y', dayDate) + '-' + Util.date('m', dayDate) + '-' + Util.date('d', dayDate)
			if (!playsByDate[dayKey]) playsByDate[dayKey] = { date: dayDate, count: 0 }
			playsByDate[dayKey].count += parseInt(playsRaw[pd].play_count, 10)
		}

		var playDayKeys = Object.keys(playsByDate)
		for (var dk = 0; dk < playDayKeys.length; dk++) {
			var day = playsByDate[playDayKeys[dk]]
			if (day.count >= 3) {
				events.push({
					date: day.date,
					type: 'play',
					label: 'Marathon day',
					detail: day.count + ' plays in one day',
					icon: 'bolt'
				})
			}
		}

		var maxPlayers = 0
		var maxPlayersDate = null
		var maxPlayersPlayId = null
		for (var mp = 0; mp < playsRaw.length; mp++) {
			var playerCount = parseInt(playsRaw[mp].play_players, 10)
			var playerDate = parseInt(playsRaw[mp].play_date, 10)
			if (playerCount > maxPlayers && playerDate > 0) {
				maxPlayers = playerCount
				maxPlayersDate = playerDate
				maxPlayersPlayId = parseInt(playsRaw[mp].play_id, 10)
			}
		}

		if (maxPlayers >= 4 && maxPlayersDate) {
			events.push({
				date: maxPlayersDate,
				type: 'opponent',
				label: 'Biggest table',
				detail: maxPlayers + ' players',
				icon: 'users',
				playId: maxPlayersPlayId
			})
		}

		var hourMilestones = [10, 25, 50, 100, 250, 500]
		var cumulativeMinutes = 0
		var hourMilestoneIndex = 0

		for (var hm = 0; hm < playsRaw.length; hm++) {
			var length = parseInt(playsRaw[hm].play_length, 10)
			var lengthDate = parseInt(playsRaw[hm].play_date, 10)
			if (length <= 0 || lengthDate <= 0) continue
			cumulativeMinutes += length
			var cumulativeHours = cumulativeMinutes / 60
			while (hourMilestoneIndex < hourMilestones.length && cumulativeHours >= hourMilestones[hourMilestoneIndex]) {
				var hours = hourMilestones[hourMilestoneIndex]
				events.push({
					date: lengthDate,
					type: 'play',
					label: hours + ' hours played',
					detail: null,
					icon: 'clock'
				})
				hourMilestoneIndex++
			}
		}

		if (runningTotal > 0) {
			var lastPlay = null
			for (var lp = playsRaw.length - 1; lp >= 0; lp--) {
				if (parseInt(playsRaw[lp].play_date, 10) > 0) {
					lastPlay = playsRaw[lp]
					break
				}
			}
			if (lastPlay) {
				events.push({
					date: parseInt(lastPlay.play_date, 10),
					type: 'play',
					label: 'Most recent play',
					detail: ordinal(runningTotal) + ' play',
					icon: 'dice',
					playId: parseInt(lastPlay.play_id, 10)
				})
			}
		}

		var gapThreshold = Constants.TIME_MONTH * 6
		var previousDate = null
		var streakMonths = 0
		var previousMonth = null

		for (var gp = 0; gp < playsRaw.length; gp++) {
			var gapDate = parseInt(playsRaw[gp].play_date, 10)
			if (gapDate <= 0) continue
			var month = Util.date('Y', gapDate) + '-' + Util.date('m', gapDate)

			if (previousDate !== null) {
				var gap = gapDate - previousDate
				if (gap >= gapThreshold) {
					var gapMonths = Math.round(gap / Constants.TIME_MONTH)

					if (streakMonths >= 3) {
						events.push({
							date: previousDate,
							type: 'streak',
							label: 'Hot play streak ended',
							detail: streakMonths + ' months playing',
							icon: 'pause'
						})
					}

					events.push({
						date: gapDate,
						type: 'play',
						label: 'Rediscovered after ' + gapMonths + ' months',
						detail: null,
						icon: 'redo',
						playId: parseInt(playsRaw[gp].play_id, 10)
					})

					streakMonths = 1
				} else if (month !== previousMonth) {
					streakMonths++
				}
			} else {
				streakMonths = 1
			}

			previousDate = gapDate
			previousMonth = month
		}

		var longestLength = 0
		var longestLengthDate = null
		var longestLengthPlayId = null
		for (var ll = 0; ll < playsRaw.length; ll++) {
			var sessionLength = parseInt(playsRaw[ll].play_length, 10)
			var sessionDate = parseInt(playsRaw[ll].play_date, 10)
			if (sessionLength > 0 && sessionDate > 0 && sessionLength > longestLength) {
				longestLength = sessionLength
				longestLengthDate = sessionDate
				longestLengthPlayId = parseInt(playsRaw[ll].play_id, 10)
			}
		}

		if (longestLength > 0 && longestLengthDate) {
			var lengthLabel = longestLength >= 60
				? (Math.round((longestLength / 60) * 10) / 10) + ' hour' + ((Math.round((longestLength / 60) * 10) / 10) === 1 ? '' : 's')
				: longestLength + ' minute' + (longestLength === 1 ? '' : 's')
			events.push({
				date: longestLengthDate,
				type: 'play',
				label: 'Longest session',
				detail: lengthLabel,
				icon: 'clock',
				playId: longestLengthPlayId
			})
		}

		if (Object.keys(byYear).length > 1) {
			var peakYear = null
			var peakCount = 0
			var byYearKeys = Object.keys(byYear)
			for (var by = 0; by < byYearKeys.length; by++) {
				var yearKey = byYearKeys[by]
				if (byYear[yearKey] > peakCount) {
					peakYear = yearKey
					peakCount = byYear[yearKey]
				}
			}
			if (peakYear) {
				events.push({
					date: Util.mktime(23, 59, 59, [31, 12, parseInt(peakYear, 10)]),
					type: 'play',
					label: 'Best year',
					detail: peakCount + ' plays in ' + peakYear,
					icon: 'fire'
				})
			}
		}

		if (bestScore !== null && bestScoreDate) {
			events.push({
				date: bestScoreDate,
				type: 'score',
				label: 'Personal best score',
				detail: String(bestScore),
				icon: 'star'
			})
		}

		if (comment && parseInt(comment.get_date(), 10) > 0) {
			events.push({
				date: parseInt(comment.get_date(), 10),
				type: 'rating',
				label: 'Commented',
				detail: null,
				icon: 'comment'
			})
		}

		var collectionLogs = Util.queryFast(
			'SELECT l.log_date AS date, l.log_context AS context FROM log_user_collection l' +
			' WHERE l.user_id = ' + userId +
			' AND l.game_id = ' + gameId +
			' AND l.log_initial_sync != 1' +
			' ORDER BY l.log_date ASC'
		)

		for (var cl = 0; cl < collectionLogs.length; cl++) {
			var collectionContext = parseInt(collectionLogs[cl].context, 10)
			events.push({
				date: parseInt(collectionLogs[cl].date, 10),
				type: 'collection',
				label: collectionContext === Constants.LOG_CONTEXT_ADDED ? 'Added to collection' : 'Removed from collection',
				detail: null,
				icon: collectionContext === Constants.LOG_CONTEXT_ADDED ? 'plus' : 'minus'
			})
		}

		var statusLogs = Util.queryFast(
			'SELECT l.log_date AS date, l.log_context AS context, l.log_status AS status FROM log_user_collection_status l' +
			' WHERE l.user_id = ' + userId +
			' AND l.game_id = ' + gameId +
			' AND l.log_initial_sync != 1' +
			' ORDER BY l.log_date ASC'
		)

		var statusNames = {}
		statusNames[Constants.COLLECTION_STATUS_PREVOWNED] = 'previously owned'
		statusNames[Constants.COLLECTION_STATUS_FORTRADE] = 'for trade'
		statusNames[Constants.COLLECTION_STATUS_WANT] = 'wanted'
		statusNames[Constants.COLLECTION_STATUS_WANTTOPLAY] = 'want to play'
		statusNames[Constants.COLLECTION_STATUS_WANTTOBUY] = 'want to buy'
		statusNames[Constants.COLLECTION_STATUS_WISHLIST] = 'wishlist'
		statusNames[Constants.COLLECTION_STATUS_PREORDERED] = 'pre-ordered'

		for (var sl = 0; sl < statusLogs.length; sl++) {
			var status = parseInt(statusLogs[sl].status, 10)
			var statusContext = parseInt(statusLogs[sl].context, 10)
			if (!statusNames[status]) continue
			events.push({
				date: parseInt(statusLogs[sl].date, 10),
				type: 'collection',
				label: (statusContext === Constants.LOG_CONTEXT_ADDED ? 'Added to ' : 'Removed from ') + statusNames[status],
				detail: null,
				icon: statusContext === Constants.LOG_CONTEXT_ADDED ? 'tag' : 'minus'
			})
		}

		var ratingLogs = Util.queryFast(
			'SELECT l.log_date AS date, l.log_context AS context, l.log_rating AS rating, l.log_previous AS previous FROM log_user_rating l' +
			' WHERE l.user_id = ' + userId +
			' AND l.game_id = ' + gameId +
			' AND l.log_initial_sync != 1' +
			' ORDER BY l.log_date ASC'
		)

		for (var rl = 0; rl < ratingLogs.length; rl++) {
			var ratingContext = parseInt(ratingLogs[rl].context, 10)
			var rating = parseFloat(ratingLogs[rl].rating)
			var previous = parseFloat(ratingLogs[rl].previous)

			if (ratingContext === Constants.LOG_CONTEXT_ADDED) {
				events.push({
					date: parseInt(ratingLogs[rl].date, 10),
					type: 'rating',
					label: 'Rated',
					detail: String(rating),
					icon: 'star'
				})
			} else if (ratingContext === Constants.LOG_CONTEXT_UPDATED) {
				events.push({
					date: parseInt(ratingLogs[rl].date, 10),
					type: 'rating',
					label: 'Rating ' + (rating > previous ? 'raised' : 'lowered'),
					detail: previous + ' → ' + rating,
					icon: rating > previous ? 'arrow-up' : 'arrow-down'
				})
			} else if (ratingContext === Constants.LOG_CONTEXT_REMOVED) {
				events.push({
					date: parseInt(ratingLogs[rl].date, 10),
					type: 'rating',
					label: 'Rating removed',
					detail: null,
					icon: 'minus'
				})
			}
		}

		for (var eo = 0; eo < events.length; eo++) events[eo]._order = eo

		events.sort(function(a, b) {
			return (a.date - b.date) || (a._order - b._order)
		})

		for (var er = 0; er < events.length; er++) delete events[er]._order

		return {
			timeline: {
				events: events,
				total: events.length
			}
		}

	}
})
